import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import { Resplit, useResplitContext } from 'react-resplit';
import RotationViewContainer from '../rotationView/RotationViewContainer';
import { RotationViewWrapper } from 'src/pages/stowage/StowagePage.styles';
import { ExpandPanelButton } from 'src/styles/button.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RotationMenuContext from 'src/components/stowage/rotationView/RotationContextMenu';

const RightPaneComponent: React.FC = () => {
    const { setPaneSizes } = useResplitContext();

    const { activeStowagePlan, isStowagePlanUpdated, isLeftPanelHidden, setIsLeftPanelHidden } = useStowageStore();

    const toggleHideLeftPanel = () => {
        if (!isLeftPanelHidden && isStowagePlanUpdated && activeStowagePlan) {
            setPaneSizes(['0fr', '6fr']);
            setIsLeftPanelHidden(true);
        } else if (isLeftPanelHidden && isStowagePlanUpdated && activeStowagePlan) {
            setPaneSizes(['1fr', '5fr']);
            setIsLeftPanelHidden(false);
        }
    };

    return (
        <Resplit.Pane asChild={true} order={0} initialSize="1fr" minSize="0.01fr">
            <RotationViewWrapper>
                <RotationViewContainer />
                <RotationMenuContext />
                <ExpandPanelButton top={'50%'} right={'-13px'} onClick={toggleHideLeftPanel}>
                    {!isLeftPanelHidden && <FontAwesomeIcon icon="chevron-left" />}
                    {isLeftPanelHidden && <FontAwesomeIcon icon="chevron-right" />}
                </ExpandPanelButton>
            </RotationViewWrapper>
        </Resplit.Pane>
    );
};

export default RightPaneComponent;
